//
// Copyright (c) 2011-2019 by Curalate, Inc.
//


import { IContentDrawerSettingsService } from '@redux/content-drawer/ContentDrawerSettingsService';
import { ContentDrawerSidebarOptions } from '@redux/content-drawer/ContentDrawerSidebarOptions';
import template from '@syndication/syndication-page/syndication-page.html';
import syndicationModule from '@syndication/syndication.module';

export class SyndicationPage {
  constructor(
    private readonly ContentDrawerSettingsService: IContentDrawerSettingsService,
  ) { }

  public $onInit() {
    this.ContentDrawerSettingsService.setPageSettings(ContentDrawerSidebarOptions.Share);
  }

  public $onDestroy() {
    this.ContentDrawerSettingsService.unsetPageSettings();
  }
}

syndicationModule.component('syndicationPage', {
  template,
  controller: [
    'ContentDrawerSettingsService',
    SyndicationPage,
  ],
});
